export const LIST_RELATORIO_ESTOQUE_POR_PERIODO = 'LIST_RELATORIO_ESTOQUE_POR_PERIODO'
export const LIST_RELATORIO_ESTOQUE_POR_PERIODO_PENDING = 'LIST_RELATORIO_ESTOQUE_POR_PERIODO_PENDING'
export const LIST_RELATORIO_ESTOQUE_POR_PERIODO_SUCCESS = 'LIST_RELATORIO_ESTOQUE_POR_PERIODO_SUCCESS'
export const LIST_RELATORIO_ESTOQUE_POR_PERIODO_PDF_SUCCESS = 'LIST_RELATORIO_ESTOQUE_POR_PERIODO_PDF_SUCCESS'
export const LIST_RELATORIO_ESTOQUE_POR_PERIODO_FAILURE = 'LIST_RELATORIO_ESTOQUE_POR_PERIODO_FAILURE'
